import {AbstractModelFactory} from '@projectstorm/react-canvas-core';
import {DiagramEngine} from '@projectstorm/react-diagrams-core';
import {DataPortModel} from "./DataPortModel";

export class DataPortFactory extends AbstractModelFactory<DataPortModel, DiagramEngine> {
    constructor() {
        super('data');
    }

    generateModel(): DataPortModel {
        return new DataPortModel({
            name: 'unknown'
        });
    }
}
